/**
 * Determine the current page referrer
 *
 * @returns {String}
 */
export default function referrer () {
  // return the current url when NOT in an iframe
  if (window.parent === window) {
    return window.location.href;
  }

  // return the parent document url when in an iframe
  return document.referrer;
}
